module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "element-loading-text": "数据加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "主体名称："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.principal_name))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "模版："
          }
        }, [(props.row.weappTemplate.name) ? _c('span', [_vm._v(_vm._s(props.row.weappTemplate.name))]) : _c('span', [_vm._v("未绑定小程序")])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "线上版本："
          }
        }, [(props.row.weappTemplate.version && props.row.weappTemplate.version == props.row.weapp.release_ver) ? _c('span', [_vm._v("最新版本")]) : (props.row.weapp.release_ver) ? _c('span', [_vm._v(_vm._s(props.row.weapp.release_ver))]) : _c('span', [_vm._v("无")])]), _vm._v(" "), (props.row.weapp.reason && props.row.weapp.audit_status == '1') ? _c('el-form-item', {
          attrs: {
            "label": "审核失败原因："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.weapp.reason))])]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "小程序头像",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(img) {
        return [(img.row.head_img) ? _c('div', [_c('img', {
          attrs: {
            "src": img.row.head_img,
            "height": "60"
          }
        })]) : _c('div', [_c('i', {
          staticClass: "iconfont icon-image fa-3x",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizer_appid",
      "label": "小程序APPID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nick_name",
      "label": "小程序名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_name) {
        return [(scope_name.row.nick_name) ? _c('div', [_vm._v("\n       " + _vm._s(scope_name.row.nick_name) + "\n     ")]) : _c('div', [_vm._v("\n      未设置\n     ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "weappTemplate.name",
      "label": "小程序模版"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "小程序上架状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(verify_type_info) {
        return [(verify_type_info.row.weapp.release_status == '1') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已上架")]) : _vm._e(), _vm._v(" "), (verify_type_info.row.weapp.audit_status == '1') ? _c('el-tag', {
          attrs: {
            "type": "gray"
          }
        }, [_vm._v("审核失败")]) : (verify_type_info.row.weapp.audit_status == '0' && verify_type_info.row.weapp.release_status != '1') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("审核成功")]) : (verify_type_info.row.weapp.audit_status == '2') ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("审核中")]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b9664d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b9664d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/wxa/index.vue
// module id = 2639
// module chunks = 0